import microApp from '@micro-zoe/micro-app'

const state = () => ({
  microAppArr: [],  // 后台返回的子应用
  microData: {},    // 子应用传参
  showApp: {},      // 展示的子应用
  microRouter: {},  // 跳转的子应用路由
})

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  SET_MICROAPPARR(state, payload) {
    // console.log('后台返回的子应用: ', payload);
    let newArr = Array.from(new Set(payload));
    state.microAppArr = newArr
  },
  SET_MICRODATA(state, payload) {
    // console.log('子应用传参: ', payload);
    state.microData = payload
  },
  SET_SHOWAPP(state, payload) {
    // console.log('切换子应用: ', payload);
    state.showApp = payload
  },
  SET_MICROROUTER(state, payload) {   // 跳转的子应用路由
    // 子应用名称
    const microAppName = state.showApp.module && state.showApp.module;
    const path = payload.url && payload.url;
    state.microRouter = payload;
    // console.log('microAppName', microAppName);
    // if(microAppName == 'gecko') {
    //   state.microRouter.path = `/main/${microAppName}/#/${path}`;
    //   console.log('跳转的子应用路由: ', `/main/${microAppName}/#/${path}`);
    // } else {
    //   state.microRouter.path = `/main/${microAppName}/#/main/${path}`;
    //   console.log('跳转的子应用路由: ', `/main/${microAppName}/#/main/${path}`);
    // }
    state.microRouter.path = `/main/${microAppName}/#/main/${path}`;
    // console.log('跳转的子应用路由: ', `/main/${microAppName}/#/main/${path}`);
    // 通知子应用进行路由跳转
    setTimeout(() => {
      microApp.setData(microAppName, { path: path });
    }, 20)
  },
  SET_DATA_TO_CHILD({ microAppArr }, payload) {   // 主应用与子应用通讯
    const { appName, params } = payload
    console.log(microAppArr, params);
    let target = microAppArr.find(app => app === appName)
    if(typeof target !== 'undefined' && target) {
      microApp.setData(appName, { params: params });
    } else {
      console.error("未找到子应用")
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/micro.js